"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _staticContent = require("../../staticContent");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var validate = (isRequired, dateValue, offset, datePickerType, dateSlots) => {
  var isValid = true;
  var currentDate = (0, _moment.default)();
  var isMomentDate = _moment.default.isMoment(dateValue);
  if (datePickerType === _staticContent.DATEPICKER_FIELD.DATEPICKER_TYPE[1]) {
    var formattedDatesArray = dateSlots.map(date => (0, _moment.default)(date).startOf('day').format('YYYY-MM-DD'));
    var dateValueFormatted = (0, _moment.default)(dateValue).startOf('day').format('YYYY-MM-DD');
    return formattedDatesArray.includes(dateValueFormatted);
  } else {
    var dayDiff = date => {
      if (isMomentDate) {
        return date.diff(currentDate.startOf('day'), 'days');
      } else {
        return (0, _moment.default)(date).diff(currentDate.startOf('day'), 'days');
      }
    };
    var daysDifference = dayDiff(dateValue);
    var validateDateWithOffset = () => {
      if (isMomentDate) {
        return daysDifference >= offset ? true : false;
      } else {
        var validStringDate = dateValue && (0, _moment.default)(dateValue, 'YYYY/MM/DD', true).isValid();
        if (validStringDate) {
          return daysDifference >= offset ? true : false;
        }
        return false;
      }
    };
    isValid = validateDateWithOffset();
    if (!dateValue && !isRequired) {
      isValid = true;
    }
    return isValid;
  }
};
var _default = exports.default = validate;